import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import Textarea from "../../coraWebComponents/forms/Textarea";
import DropDownList from "../../coraWebComponents/forms/DropDownList";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Tooltip from "../../coraWebComponents/forms/Tooltip";

// prop types
import vysledokVyjadreniaPropTypes from "../../propTypes/vysledokVyjadreniaPropTypes";
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";

// actions
import * as vysledokVyjadreniaActions from "../../actions/ciselniky/zpCVysledokVyjadreniaActions";
import * as vyjadrenieActions from "../../actions/vyjadrenieActions";

class Vyjadrenie extends React.Component {
  constructor(props) {
    super(props);
    const vyjadrenie = props.vyjadrenie?.vyjadrenie;

    this.state = {
      komentar: vyjadrenie ? vyjadrenie.komentar : "",
      titles: {
        vysledok: "Výsledok",
        komentar: "Vyjadrenie",
      },
    };
  }

  saveData = async () => {
    const { vysledok, ulozData } = this.props;
    const { komentar } = this.state;

    const data = {
      vysledok: vysledok.N_VYSLEDOK,
      komentar,
      ...vysledok,
    };

    ulozData({ vyjadrenie: data });
  };

  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };

  // DROP DOWN - VYSLEDOK PROPS
  handleOnChangeVysledok = async (name, vysledok) => {
    await this.props.changeVysledokVyjadrenia(vysledok);
  };

  componentDidMount = async () => {
    const { vysledky, getVysledkyVyjadrenia, setRef } = this.props;

    setRef(this);
    if (vysledky.length === 0) await getVysledkyVyjadrenia();
  };

  render() {
    const {
      className,
      cancel,
      moveBack,
      moveNext,
      onKeyDown,
      vysledky,
      vysledok,
      index,
      ziadost
    } = this.props;
    const { komentar, titles } = this.state;
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-8 offset-2 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              <Tooltip>
                {/* FORM */}
                <form
                  id={`webForm${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  <div className="card-title">
                    <div>Vyjadrenie k žiadosti {ziadost.KOD_ZIADOSTI}</div>
                  </div>

                  {/* VYSLEDKY */}
                  <div className="k-form-field">
                    <span>{"*Výsledok vyjadrenia:"}</span>
                    <DropDownList
                      className="basicwhiteBackground"
                      name="vysledok"
                      textField="N_VYSLEDOK"
                      data={vysledky}
                      onChange={this.handleOnChangeVysledok}
                      value={vysledok}
                      notSetValue={!vysledok}
                      required
                    />
                  </div>
                  <p>&nbsp;</p>

                  {/* VYJADRENIE */}
                  <div className="k-form-field">
                    <span>{"Vyjadrenie:"}</span>
                    <Textarea
                      title={titles.komentar}
                      name="komentar"
                      onChange={this.handleOnChange}
                      value={komentar}
                      defaultExpanded={true}
                    />
                  </div>

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={cancel} />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button primary label="Ďalej" onClick={moveNext} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={false} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vysledok: state.zpCVysledokVyjadrenia.item,
    vysledky: state.zpCVysledokVyjadrenia.list,
    ziadost: state.ziadost.data,
    vyjadrenie: state.vyjadrenie.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeVysledokVyjadrenia: (data) =>
    dispatch(vysledokVyjadreniaActions.changeVysledokVyjadrenia(data)),
  getVysledkyVyjadrenia: () =>
    dispatch(vysledokVyjadreniaActions.getZP_C_VYSLEDOK_VYJADRENIA()),
  ulozData: (data) => dispatch(vyjadrenieActions.ulozData(data)),
});

Vyjadrenie.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  changeVysledokVyjadrenia: PropTypes.func,
  getVysledkyVyjadrenia: PropTypes.func,
  ulozData: PropTypes.func,
  vysledok: vysledokVyjadreniaPropTypes.vysledokVyjadrenia,
  vysledky: PropTypes.arrayOf(vysledokVyjadreniaPropTypes.vysledokVyjadrenia),
  className: PropTypes.string,
  ziadost: ziadostPropTypes.ziadost,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Vyjadrenie)
);
